import React from "react";
import "./itemStyles.css";
import { FormattedMessage } from "react-intl";

const ConsentItem = ({ consent }) => {
  const { sampleImg, description } = consent;
  return (
    <div>
      <div className="image-container">
        <p className="sample-text">
          <FormattedMessage id="label.sample" defaultMessage="SAMPLE" />
        </p>
        <img style={{ margin: "0 auto", height: 300 }} src={sampleImg} />
      </div>
      <p className="description">{description}</p>
    </div>
  );
};

export default ConsentItem;
